'use client';

import React from 'react';
import Hero from '@/components/home/hero';
import Categories from '@/components/home/categories';
import FeaturedRestaurants from '@/components/home/featured-restaurants';

export default function Home() {
  return (
    <>
      <Hero />
      <Categories />
      {/* <FeaturedRestaurants /> */}
      
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-4">Experience the Luxury of Qmin Hospitality at Home</h2>
              <p className="text-gray-600 mb-6">
                With Qmin, we bring the culinary excellence of Qmin's iconic restaurants directly to your doorstep. 
                Enjoy the same quality, taste, and presentation that you would expect from dining at our prestigious establishments.
              </p>
              <ul className="space-y-3">
                {[
                  'Curated menus from renowned Qmin restaurants',
                  'Contactless delivery for your safety',
                  'Sustainably packaged meals',
                  'Premium quality ingredients',
                  'Exclusive offers for loyal customers'
                ].map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#900f21] font-bold mr-2">✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="relative h-80 md:h-96 bg-gray-200 rounded-lg overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-b from-[#900f21]/20 to-[#900f21]/40 flex items-center justify-center">
                <span className="text-white text-2xl font-bold">Qmin Experience</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-16 bg-[#900f21] text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Download the Qmin App</h2>
            <p className="max-w-2xl mx-auto">
              Get the full Qmin experience on your mobile device. Order food, track deliveries, and earn exclusive rewards.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          <a href="https://play.google.com/store/apps/details?id=com.tatadigital.qmin&hl=en_IN" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-white text-[#900f21] font-semibold py-3 px-8 rounded-lg flex items-center"
          >
            <span className="mr-2">Google Play</span>
          </a>
          <a href="https://apps.apple.com/in/app/qmin/id1516220465" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-white text-[#900f21] font-semibold py-3 px-8 rounded-lg flex items-center"
          >
            <span className="mr-2">App Store</span>
          </a>
        </div>
        </div>
      </section>
    </>
  );
}
